import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=d47b58b0"
import script from "./HeaderNotification.vue?vue&type=script&lang=js"
export * from "./HeaderNotification.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotification.vue?vue&type=style&index=0&id=d47b58b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports